import { render, staticRenderFns } from "./ReserveFundFunction.vue?vue&type=template&id=6f1d7b95"
import script from "./ReserveFundFunction.vue?vue&type=script&lang=js"
export * from "./ReserveFundFunction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports